export default [
  { label: 'English', value: 'eng' },
  { label: 'Portuguese', value: 'por' },
  { label: 'Spanish', value: 'spa' },
]

export const languagesWithMusic = {
  all: 'Music topics',
  eng: 'English topics',
  por: 'Portuguese topics',
  spa: 'Spanish topics',
}
